"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastProvider = exports.useToast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * ToastProvider - manages toast notifications
 */
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const Toast_1 = __importDefault(require("../components/Toast"));
require("../components/Toast.scss");
const ToastContext = (0, react_1.createContext)(undefined);
/**
 * Hook to access toast functionality
 * @returns Toast context value
 * @throws Error if used outside ToastProvider
 */
const useToast = () => {
    const context = (0, react_1.useContext)(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within ToastProvider');
    }
    return context;
};
exports.useToast = useToast;
/**
 * ToastProvider component that manages toast notifications
 * @param props - Provider props with children
 * @returns ToastProvider component
 */
const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = (0, react_1.useState)([]);
    const dismissToast = (0, react_1.useCallback)((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);
    const showToast = (0, react_1.useCallback)((options) => {
        const id = `toast-${Date.now()}-${Math.random()}`;
        const newToast = Object.assign(Object.assign({}, options), { id });
        setToasts((prev) => [...prev, newToast]);
    }, []);
    const success = (0, react_1.useCallback)((message, duration) => {
        showToast({ type: 'success', message, duration });
    }, [showToast]);
    const error = (0, react_1.useCallback)((message, duration) => {
        showToast({ type: 'error', message, duration });
    }, [showToast]);
    const warning = (0, react_1.useCallback)((message, duration) => {
        showToast({ type: 'warning', message, duration });
    }, [showToast]);
    const info = (0, react_1.useCallback)((message, duration) => {
        showToast({ type: 'info', message, duration });
    }, [showToast]);
    const contextValue = (0, react_1.useMemo)(() => ({
        showToast,
        success,
        error,
        warning,
        info,
    }), [showToast, success, error, warning, info]);
    return ((0, jsx_runtime_1.jsxs)(ToastContext.Provider, { value: contextValue, children: [children, (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", { className: "toast-container", children: toasts.map((toast) => ((0, jsx_runtime_1.jsx)(Toast_1.default, { id: toast.id, type: toast.type, message: toast.message, duration: toast.duration, onDismiss: dismissToast }, toast.id))) }), document.body)] }));
};
exports.ToastProvider = ToastProvider;
exports.default = exports.ToastProvider;
